module.exports = __webpack_public_path__ + "img/login_slide_04.5696ba8d.webp";